import { Card, CardMedia, Stack } from "@mui/material";

import utilizationInsightsAverageHoursPerDay from "../../resources/images/UtilizationInsightsAverageHoursPerDay.png";
import utilizationInsightsGhostHoursOptimization from "../../resources/images/UtilizationInsightsGhostHoursOptimization.png";
import utilizationInsightsOccupancyScore from "../../resources/images/UtilizationInsightsOccupancyScore.png";
import utilizationInsightsUserSatisfaction from "../../resources/images/UtilizationInsightsUserSatisfaction.png";
import utilizationInsightsPerLocation from "../../resources/images/UtilizationInsightsPerLocation.png";
import utilizationInsightsBusiestTimeSlots from "../../resources/images/UtilizationInsightsBusiestTimeSlots.png";
import GhostHoursOptimization from "./Insights/GhostHoursOptimization";

const UtilizationInsights = () => {
  return (
    <>
      <Stack
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        direction={{ xs: "column", xl: "row" }}
        spacing={{ xs: 2, xl: 3 }}
        margin={{ xs: 2, xl: 3 }}
      >
        <Card sx={{ padding: 4, borderRadius: 4 }}>
          <CardMedia
            component="img"
            src={utilizationInsightsAverageHoursPerDay}
            alt="Impact Interventions"
            style={{ objectFit: "contain" }}
          />
        </Card>
        <GhostHoursOptimization />
        <Card sx={{ padding: 4, borderRadius: 4 }}>
          <CardMedia
            component="img"
            src={utilizationInsightsOccupancyScore}
            alt="Impact Interventions"
            style={{ objectFit: "contain" }}
          />
        </Card>
      </Stack>
      <Stack
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        direction={{ xs: "column", xl: "row" }}
        spacing={{ xs: 2, xl: 3 }}
        margin={{ xs: 2, xl: 3 }}
      >
        <Card sx={{ padding: 4, borderRadius: 4 }}>
          <CardMedia
            component="img"
            src={utilizationInsightsUserSatisfaction}
            alt="Impact Interventions"
            style={{ objectFit: "contain" }}
          />
        </Card>
        <Card sx={{ padding: 4, borderRadius: 4 }}>
          <CardMedia
            component="img"
            src={utilizationInsightsPerLocation}
            alt="Impact Interventions"
            style={{ objectFit: "contain" }}
          />
        </Card>
        <Card sx={{ padding: 4, borderRadius: 4 }}>
          <CardMedia
            component="img"
            src={utilizationInsightsBusiestTimeSlots}
            alt="Impact Interventions"
            style={{ objectFit: "contain" }}
          />
        </Card>
      </Stack>
    </>
  );
};

export default UtilizationInsights;
